import axios from "axios";
import { generateUUID } from "../utils/Functions";
import { baseURL } from "../config";

const MAPS_PROXY_BASE_URL = `${baseURL}/api/v1/maps/places`;
const MAPS_CONFIG_URL = `${baseURL}/api/v1/maps/config`;

const normalizeBrowserMapKey = (rawKey) =>
  String(rawKey || "")
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/;+$/g, "")
    .trim();

let cachedPublicBrowserKey = "";

export const getOlaPublicBrowserKey = async () => {
  if (cachedPublicBrowserKey) return cachedPublicBrowserKey;

  try {
    const response = await axios.get(MAPS_CONFIG_URL, {
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });
    cachedPublicBrowserKey = normalizeBrowserMapKey(
      response?.data?.data?.publicBrowserKey,
    );
    return cachedPublicBrowserKey;
  } catch (error) {
    console.error(
      "Ola Map Configuration Error:",
      error.response?.data || error.message,
    );
    return "";
  }
};

export const searchPlaces = async (query) => {
  if (!query || query.length < 3) return [];

  try {
    const response = await axios.get(`${MAPS_PROXY_BASE_URL}/autocomplete`, {
      params: {
        input: query,
      },
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });

    return response?.data?.data || [];
  } catch (error) {
    console.error("Ola Search Error:", error.response?.data || error.message);
    return [];
  }
};

export const getPlaceDetails = async (placeId) => {
  try {
    const response = await axios.get(`${MAPS_PROXY_BASE_URL}/details`, {
      params: {
        place_id: placeId,
      },
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });

    return response?.data?.data || null;
  } catch (error) {
    console.error("Ola Details Error:", error.response?.data || error.message);
    return null;
  }
};

export const reverseGeocodePlace = async (coordinates) => {
  try {
    const response = await axios.get(`${MAPS_PROXY_BASE_URL}/reverse-geocode`, {
      params: {
        lat: coordinates.lat,
        lng: coordinates.lng,
      },
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });

    return response?.data?.data || null;
  } catch (error) {
    console.error(
      "Ola Reverse Geocode Error:",
      error.response?.data || error.message,
    );
    return null;
  }
};
